import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import NavItem from "./navItem";
import { Home, ReportIcon, WorkerIcon, File, Gear } from "./assets/Icons";
import SubMenu from "./subMenu";

const NavMenu = ({ location, accountPermission }) => {
  const {
    seeFinancialReports,
    seeTimesheets,
    seeBookings,
    isPecan,
    isSeniorArcSystems,
    seeReflexAndAllenDocuments,
    isGreatBear,
    isKingspan,
    isPusterla,
    isRegatta,
    isCarltonForest,
    isCPI,
    isMolecular,
    isCompleatFood,
    isThanetDistrictCouncil,
    isWoodland,
    isGrowUpFarms,
    isSigma,
    isUps,
    isDavinFoods,
    isIpn,
    isAldi,
    isSpecialityBreads
  } = accountPermission;

  const activePath = location.pathname;

  const regattaPaths = [
    "/documentationREG",
    "/regatta-starters",
    "/regatta-absenses",
    "/regatta-attrition",
    "/regatta-leavers"
  ];

  const resourcesPaths = ["/resources", "/timesheets", "/vacancies"];

  const financialManagmentPaths = [
    "/financials",
    "/credit-summary",
    "/worker-summary"
  ];

  const specialityBreadsPaths = [
    "/speciality-breads-total-hours-report",
    "/speciality-breads-absences-report"
  ];

  const greatBarPaths = ["/documentationGB", "/great-bear-report"];

  const ipnPaths = ["/ipn-report", "/ipn-induction"];

  return (
    <Fragment>
      <div className="tw-border-b tw-border-gray-200 tw-pt-10 tw-pb-8">
        <div
          style={{
            backgroundImage: `url("https://hrgo.co.uk/images/dashboard/nav_background2.jpg")`,
            backgroundSize: "cover"
          }}
        >
          <ul className="container tw-flex tw-flex-wrap tw-justify-between tw--mb-px tw-text-sm tw-text-lg tw-text-center tw-text-white">
            <NavItem to="/" icon={Home()} pathName="Home" display={true} />
            <NavItem
              to="/financials"
              icon={ReportIcon()}
              pathName="Financial Management"
              display={seeFinancialReports}
              subMenuPaths={financialManagmentPaths}
            />
            <NavItem
              to="/resources"
              icon={WorkerIcon()}
              pathName="Resource Management"
              display={seeTimesheets || seeBookings}
              subMenuPaths={resourcesPaths}
            />
            <NavItem
              to="/ipn-report"
              icon={File()}
              pathName="IPN"
              display={isIpn}
              subMenuPaths={ipnPaths}
            />
            <NavItem
              to="/aldi-report"
              icon={File()}
              pathName="Aldi Report"
              display={isAldi}
            />
            <NavItem
              to="/speciality-breads-total-hours-report"
              icon={File()}
              pathName="Speciality Breads Reports"
              display={isSpecialityBreads}
              subMenuPaths={specialityBreadsPaths}
            />
            <NavItem
              to="/documentationPEC"
              icon={File()}
              pathName="Pecan Deluxe Candy"
              display={isPecan}
            />
            <NavItem
              to="/documentationGB"
              icon={File()}
              pathName="Great Bear Onboarding"
              display={isGreatBear}
            />
            <NavItem
              to="/documentationK"
              icon={File()}
              pathName="Kingspan Onboarding"
              display={isKingspan}
            />
            <NavItem
              to="/documentationPUS"
              icon={File()}
              pathName="Pusterla Onboarding"
              display={isPusterla}
            />
            <NavItem
              to="/documentationREG"
              icon={File()}
              pathName="Regatta Onboarding"
              display={isRegatta}
              subMenuPaths={regattaPaths}
            />
            <NavItem
              to="/documentation"
              icon={File()}
              pathName="Onboarding"
              display={seeReflexAndAllenDocuments}
            />

            <NavItem
              to="/documentationSAS"
              icon={File()}
              pathName="Senior Architectural Systems"
              display={isSeniorArcSystems}
            />
            <NavItem
              to="/documentationCPI"
              icon={File()}
              pathName="CPI Onboarding"
              display={isCPI}
            />
            <NavItem
              to="/documentationCF"
              icon={File()}
              pathName="Carlton Forest Onboarding"
              display={isCarltonForest}
            />
            <NavItem
              to="/documentationMolecular"
              icon={File()}
              pathName="Molecular Onboarding"
              display={isMolecular}
            />
            <NavItem
              to="/documentationTDC"
              icon={File()}
              pathName="Thanet District Council Onboarding"
              display={isThanetDistrictCouncil}
            />
            <NavItem
              to="/documentationCompleatFood"
              icon={File()}
              pathName="Compleat Food Onboarding"
              display={isCompleatFood}
            />
            <NavItem
              to="/documentationWoodland"
              icon={File()}
              pathName="Woodland Onboarding"
              display={isWoodland}
            />
            <NavItem
              to="/documentationGrowUpFarms"
              icon={File()}
              pathName="GrowUp Farms Induction Pack"
              display={isGrowUpFarms}
            />
            <NavItem
              to="/documentationSigma"
              icon={File()}
              pathName="Sigma Documents"
              display={isSigma}
            />
            <NavItem
              to="/documentationUps"
              icon={File()}
              pathName="UPS Documents"
              display={isUps}
            />
            <NavItem
              to="/documentationDF"
              icon={File()}
              pathName="Davin Foods Induction Pack"
              display={isDavinFoods}
            />
            <NavItem
              to="/settings"
              icon={Gear()}
              pathName="Settings"
              display={true}
            />
          </ul>
        </div>
      </div>
      {regattaPaths.includes(activePath) && <SubMenu clientName="regatta" />}
      {resourcesPaths.includes(activePath) && (
        <SubMenu
          seeTimesheets={seeTimesheets}
          seeBookings={seeBookings}
          clientName="resources"
        />
      )}
      {ipnPaths.includes(activePath) && <SubMenu clientName="ipn" />}
      {greatBarPaths.includes(activePath) && <SubMenu clientName="greatBear" />}
      {financialManagmentPaths.includes(activePath) && (
        <SubMenu clientName="financial" />
      )}
      {specialityBreadsPaths.includes(activePath) && (
        <SubMenu clientName="speciality-breads" />
      )}
    </Fragment>
  );
};

export default withRouter(NavMenu);
